<template>
  <NuxtLink to="/" class="editorial-wordmark" aria-label="Filip Hric home">
    <span>
      FILIP
      <span class="wordmark-surname">HRIC</span>
    </span>
  </NuxtLink>
</template>
